module.exports = "/_next/static/images/logo-my-med-light-fd3d9a77ae0fdcd12b61c80817cd5954.svg";